const richTextStyles = {
  '> *:first-child, > *:first-child > *:first-child, > *:first-child > *:first-child > *:first-child': {
    mt: 0,
  },
  '> *:last-child, > *:last-child > *:last-child, > *:last-child > *:last-child > *:last-child': {
    mb: 0,
  },
}

export default richTextStyles
